import { accessibilityCheckerBgUrl } from '@/assets/images';
import { StyledCol, StyledRow, StyledText } from '@/shared/styles';
import { isMobileOnly } from 'react-device-detect';
import styled from 'styled-components';

export const StyledScanUrl = styled(StyledCol)`
  background: url(${accessibilityCheckerBgUrl});
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  gap: 64px;
  align-items: center;

  ${isMobileOnly
    ? `padding: 24px;`
    : `
  padding: 120px 200px;

  @media (max-width: 878px) {
    padding: 100px;
  }
    `}
`;

export const StyledBottomText = styled(StyledText)`
  font-size: 16px !important;
  font-weight: 400 !important;
`;

export const StyledInputRow = styled(StyledRow)`
  gap: 24px;

  .ant-input-affix-wrapper::before {
    content: none;
  }

  .ant-input-affix-wrapper {
    gap: 12px;
  }

  .ant-input-prefix {
    margin: 0;
  }

  ${isMobileOnly && `flex-wrap: wrap;`}
`;

export const StyledLoadingScan = styled(StyledCol)`
  gap: 40px;
  align-items: center;
`;
